import { useEffect, useState } from 'react'

export function useCountdown(targetMs: number): number {
  const [remaining, setRemaining] = useState(0)

  useEffect(() => {
    if (!targetMs) { setRemaining(0); return }

    const tick = () => {
      const left = Math.max(0, Math.ceil((targetMs - Date.now()) / 1000))
      setRemaining(left)
    }
    tick()
    const id = setInterval(tick, 200)
    return () => clearInterval(id)
  }, [targetMs])

  return remaining
}
